export const SHOW_RESULTS_TYPES = Object.freeze({
    PERCENTAGE_EMISSIONS_ID: 1,
    PERCENTAGE_ELECTORAL_ROLL_ID: 2,
    PERCENTAGE_VALIDATE_EMISSIONS_ID: 3
})